module.exports = __webpack_public_path__ + "img/product.657dd49f.png";